import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  delete_alert_popup,
  studentDashboard_AI_chatbot_image,
  swap_vert,
  delete_icon
} from "../../assets/images/images";
import { useAuth } from "../../features/auth/AuthContext";
import { getSentInvitationList, resetInvitationList } from "../../state/actions/sentInvitationListAction";
import BackButton from "../BackButton/BackButton";
import PaginationView from "../PaginationView/PaginationView";
import SearchBar from "../Search/SearchBar"
import { CircularProgress, Grid } from "@mui/material";
import RemovePopup from "../RemovePopup/RemovePopup";
import { toast } from "react-toastify";
import { removeStudentsFromCourse, resetremovestudents } from "../../state/actions/removeStudentsFromCourseAction";

/** Status filter values from Filter.jsx: "Enrolled" | "Invited" | "Invited & Enrolled" */
function itemMatchesStatusFilter(item, status) {
  switch (status) {
    case "Invited & Enrolled":
      return item?.source === "Invited" && item?.student != null;
    case "Invited":
      return item?.student == null;
    case "Enrolled":
      return item?.source === "Enrolled";
    default:
      return item?.source === status;
  }
}

const Invitedstudentslist = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sortOption, setSortOption] = useState("Newest");
  const [filterOption, setfilterOption] = useState("");
  const [removeStudentsArray, setremoveStudentsArray] = useState([]);
  const [sortColumnHeader, setSortColumnHeader] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [isBulkDeleteMode, setIsBulkDeleteMode] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [isVisiblefillter, setIsVisiblefillter] = useState(false);






  const filterArray = [
    { id: "Invited", name: "Invited & Enrolled" },
    { id: "Enrolled", name: "Enrolled" },
    { id: "", name: "All" },
  ]

  const navigate = useNavigate();
  const location = useLocation();
  const myRole = location.state?.course?.my_role;
  const showDeleteColumn = myRole === "owner";
  const { token } = useAuth();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { count,
    next,
    previous,
    totalPages,
    error, invitations, isLoading } = useSelector((state) => state.sentInvitations);
  const removestudentfromcourse = useSelector((state) => state.removestudentfromcourse);

  const SORTABLE_HEADERS = ["Student Name", "Invited On"];
  const showSortIcon = (header) => SORTABLE_HEADERS.includes(header);

  const handleSortClick = (header) => {
    if (!showSortIcon(header)) return;
    const isDateCol = header === "Invited On";
    if (sortColumnHeader === header) {
      setSortDirection((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortColumnHeader(header);
      setSortDirection(isDateCol ? "desc" : "asc");
    }
  };

  const getEnrolledOnValue = (invitation) => {
    if (invitation?.source === "Enrolled") return invitation?.invited_on ?? null;
    return invitation?.enrolled_on ?? null;
  };

  const getInvitedOnValue = (invitation) => invitation?.invited_on ?? null;

  const sortedInvitations = useMemo(() => {
    let list = [...(invitations ?? [])];

    if (appliedFilter) {
      const { invited_by: filterInvitedBy, status: filterStatus, start_date, end_date } = appliedFilter;

      if (filterInvitedBy?.length > 0) {
        list = list.filter((item) => filterInvitedBy.includes(item?.invited_by));
      }

      if (filterStatus?.length > 0) {
        list = list.filter((item) =>
          filterStatus.some((s) => itemMatchesStatusFilter(item, s)),
        );
      }

      if (start_date != null && end_date != null) {
        const start = new Date(start_date).getTime();
        const end = new Date(end_date).getTime();
        list = list.filter((item) => {
          const enrolledOn = item?.invited_on;
          if (enrolledOn == null) return false;
          const enrolledTime = new Date(enrolledOn).getTime();
          return enrolledTime >= start && enrolledTime <= end;
        });
      }
    }

    if (!list.length || !sortColumnHeader) return list;
    if (sortColumnHeader === "Student Name") {
      list.sort((a, b) => {
        const strA = String(a?.student_name ?? "").toLowerCase();
        const strB = String(b?.student_name ?? "").toLowerCase();
        const cmp = strA.localeCompare(strB);
        return sortDirection === "asc" ? cmp : -cmp;
      });
    } else if (sortColumnHeader === "Invited On") {
      list.sort((a, b) => {
        const valA = getInvitedOnValue(a);
        const valB = getInvitedOnValue(b);
        const timeA = valA ? new Date(valA).getTime() : 0;
        const timeB = valB ? new Date(valB).getTime() : 0;
        if (sortDirection === "asc") return timeA - timeB;
        return timeB - timeA;
      });
    }
    return list;
  }, [invitations, appliedFilter, sortColumnHeader, sortDirection]);

  const getSentInvitationListReq = () => {
    const studentIds = location.state?.student_ids;

    dispatch(getSentInvitationList(id, currentPage, token, search, filterOption, sortOption, location.state?.teacher_id, studentIds))
  }

  const onStudentViewProfile = (id) => {
    navigate(`/student/${id}`);
  }

  const formatDate = (isoTimestamp) => {
    const fixedDateTime = new Date(isoTimestamp);

    // Get individual date components
    const readableFormat = fixedDateTime.toLocaleString('en-US', {
      month: 'short', // Short name of the month
      day: 'numeric', // Numeric day of the month
      year: 'numeric', // Numeric year
    });
    return readableFormat;
  }

  useEffect(() => {
    getSentInvitationListReq();

    return () => {
      dispatch(resetInvitationList());
    }
  }, [currentPage, search, sortOption, filterOption, removestudentfromcourse])

  useEffect(() => {
    if (removestudentfromcourse?.message?.length) {
      toast.success(removestudentfromcourse.message);
      setremoveStudentsArray([]);
      setIsBulkDeleteMode(false);
      handleClose();
    }
    else if (removestudentfromcourse?.error?.length) {
      toast.error(removestudentfromcourse.error);
      handleClose();
    }

    return () => {
      dispatch(resetremovestudents());
    }
  }, [removestudentfromcourse])

  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

  // Function to close the popup
  const handleClose = () => {
    setremoveStudentsArray([])
    setIsDeletePopupOpen(false);
    setIsBulkDeleteMode(false);
  };

  // Function to handle the action after confirmation (optional extra functionality)
  const handleRemoveStudent = () => {

    const req = {
      student_emails: removeStudentsArray,
      course_id: id
    }


    dispatch(removeStudentsFromCourse(req, token))
  }

  // Function to open the popup
  const handleOpenPopup = (email) => {
    if (email) {
      setremoveStudentsArray([email]);
      setIsBulkDeleteMode(false); // Individual delete mode
    } else {
      setIsBulkDeleteMode(true); // Bulk delete mode
    }
    setIsDeletePopupOpen(true);
  };

  const handleDeleteCheck = (e) => {
    setIsBulkDeleteMode(true); // Using checkbox, so bulk delete mode
    if (removeStudentsArray.some(element => element === e.target.value)) {
      setremoveStudentsArray(removeStudentsArray.filter(element => element !== e.target.value))
    }
    else {
      setremoveStudentsArray([...removeStudentsArray, e.target.value]);
    }
  }

  const handleDeleteAll = (e) => {
    setIsBulkDeleteMode(true); // Using checkbox, so bulk delete mode
    if (e.target.checked) {
      setremoveStudentsArray(invitations.map(student => student.email));
    }
    else {
      setremoveStudentsArray([]);
    }
  }


  const handleApplyFilter = (filterObj) => {
    setAppliedFilter(filterObj);
    setIsVisiblefillter(false);
  };

  const handleResetFilter = () => {
    setAppliedFilter(null);
  };

  const hasPurchasedInvitation = sortedInvitations.some(
    (invitation) => invitation?.source === "Purchased"
  );

  return (
    <>
      <div id="invited-student-list-section">
        <div className="view-course-Details-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="view-course-Details-back-btn-folder">
                  <BackButton buttonName={"Invited students list"} />
                </div>
                <SearchBar
                  search={search}
                  setSearch={setSearch}
                  filterArray={filterArray}
                  sortOption={sortOption}
                  setSortOption={setSortOption}
                  filterOption={filterOption}
                  setfilterOption={setfilterOption}
                  title="Invited Students"
                  invitationsForFilter={invitations}
                  handleApplyFilter={handleApplyFilter}
                  onResetFilter={handleResetFilter}
                  isVisiblefillter={isVisiblefillter}
                  setIsVisiblefillter={setIsVisiblefillter}
                />
                {isBulkDeleteMode && removeStudentsArray.length > 0 && !isDeletePopupOpen && (
                  <div style={{ marginBottom: "15px", display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ marginRight: '10px', fontSize: '13px' }}>{removeStudentsArray.length} Selected</span>
                    <button
                      type="button"
                      style={{ backgroundColor: 'transparent', color: 'red', cursor: 'pointer', border: 'none', fontSize: '13px' }}
                      onClick={() => handleOpenPopup()}
                      disabled={removeStudentsArray.length === 0}
                    >
                      Remove
                    </button>
                  </div>
                )}
                <div className="invited-student-list-table-wrapper">
                  <div className="list-of-students-wrappper student-request-wrapper" style={{ boxShadow: 'none' }}>
                    <div className="mobile-cards-wrapper">
                      {isLoading ? (
                        <Grid height="50vh" xs={12} container justifyContent="center" alignItems="center">
                          <CircularProgress size={80} />
                        </Grid>
                      ) : sortedInvitations?.length > 0 ? (
                        sortedInvitations.map((invitation, index) => (
                          <div key={index} className="mobile-student-card" style={{ boxShadow: '0px 0px 8px 0px #0000001F' }}>

                            {/* Header: checkbox + profile + status + delete */}
                            <div className="flex items-center justify-between gap-2">
                              {showDeleteColumn ? (
                                <input type="checkbox" value={invitation?.email}
                                  onChange={handleDeleteCheck}
                                  checked={removeStudentsArray.some(el => el === invitation?.email)}
                                />
                              ) : (
                                <span aria-hidden style={{ visibility: "hidden" }}><input type="checkbox" disabled /></span>
                              )}

                              <div className="flex items-center gap-2 flex-1">
                                <div className="studentrequest-profile-image">
                                  <img className="rounded-full w-10" src={invitation?.student_profile_pic || studentDashboard_AI_chatbot_image} alt="Student" />
                                </div>
                                <div className="text-left">
                                  <p className="text-[14px] font-medium text-[#000] m-0">{invitation?.student_name}</p>
                                  {/* Status Badge */}
                                  <div
                                    className="text-[11px] px-2 py-[2px] rounded-full w-fit"
                                    style={{
                                      backgroundColor: !invitation?.student ? "#FFECD6" : invitation?.source === "Enrolled" ? "#e6ffe5" : invitation?.source === "Invited" ? "#e8f0ff" : "#ffd6d6",
                                      color: !invitation?.student ? "#FF8A00" : invitation?.source === "Enrolled" ? "#28991f" : invitation?.source === "Invited" ? "#0068ff" : "#b24747"
                                    }}
                                  >
                                    {!invitation?.student ? "Invited" : invitation?.source === "Invited" ? invitation?.source + " & Enrolled" : invitation?.source}
                                  </div>
                                </div>
                              </div>

                              {showDeleteColumn ? (
                                <img src={delete_icon} alt="Delete" role="button"
                                  onClick={() => handleOpenPopup(invitation?.email)}
                                  className="cursor-pointer h-5 w-5"
                                />
                              ) : (
                                <span aria-hidden style={{ visibility: "hidden" }}><img src={delete_icon} alt="" className="h-5 w-5" /></span>
                              )}
                            </div>

                            {/* Invited By + Enrolled On */}
                            <div className="flex justify-between text-left">
                              <div>
                                <p className="text-[12px] text-[#000] font-medium m-0">Invited By</p>
                                <div className="flex items-center gap-1">
                                  <p className="text-[13px] text-[#888] m-0">{invitation?.invited_by ?? "-"}</p>
                                </div>
                              </div>
                              <div>
                                <p className="text-[12px] text-[#000] font-medium m-0">Enrolled On</p>
                                <p className="text-[13px] text-[#888] m-0">
                                  {invitation?.invited_on ? formatDate(invitation?.invited_on) : "-"}
                                </p>
                              </div>
                            </div>

                            {/* Email */}
                            <div className="text-left">
                              <p className="text-[12px] text-[#000] font-medium m-0">Email Id</p>
                              <p className="text-[13px] text-[#888] m-0">{invitation?.email ?? "-"}</p>
                            </div>

                            {/* View Profile */}
                            <button type="button"
                              className="flex justify-center w-full rounded-lg py-2 text-sm"
                              style={{
                                background: 'white',
                                border: '2px solid #0068ff',
                                color: '#0068ff',
                                pointerEvents: invitation?.student_name ? 'auto' : 'none',
                                opacity: invitation?.student_name ? 1 : 0.5
                              }}
                              onClick={() => { if (!invitation?.student_name) return; onStudentViewProfile(invitation.student); }}
                            >
                              View Profile
                            </button>
                          </div>
                        ))
                      ) : (
                        <p className="text-center text-[13px] text-[#888]">No Invitation Found</p>
                      )}
                    </div>
                    <table className="desktop-table">
                      <thead>
                        <tr style={{ boxShadow: 'none', backgroundColor: ' ' }} >
                          {/* <th data-label="Name" style={{ width: "40px" }}>
                            {showDeleteColumn ? (
                              <input
                                type="checkbox"
                                value={"all"}
                                onChange={handleDeleteAll}
                                checked={removeStudentsArray.length > 0 && removeStudentsArray.length === invitations.length}
                              />
                            ) : (
                              <span aria-hidden style={{ visibility: "hidden" }}>
                                <input type="checkbox" disabled />
                              </span>
                            )}
                          </th> */}

                          <th data-label="Name" style={{ width: "40px" }}>
                            {showDeleteColumn ? (
                              hasPurchasedInvitation ? (
                                "-"
                              ) : (
                                <input
                                  type="checkbox"
                                  value="all"
                                  onChange={handleDeleteAll}
                                  checked={
                                    removeStudentsArray.length > 0 &&
                                    removeStudentsArray.length === invitations.length
                                  }
                                />
                              )
                            ) : (
                              <span aria-hidden style={{ visibility: "hidden" }}>
                                <input type="checkbox" disabled />
                              </span>
                            )}
                          </th>
                          <th>
                            Student Name
                            {showSortIcon("Student Name") && (
                              <img
                                src={swap_vert}
                                alt=""
                                role="button"
                                tabIndex={0}
                                onClick={() => handleSortClick("Student Name")}
                                onKeyDown={(e) => e.key === "Enter" && handleSortClick("Student Name")}
                                style={{ marginLeft: "5px", verticalAlign: "middle", height: "14px", cursor: "pointer" }}
                              />
                            )}
                          </th>
                          <th>Email Id</th>
                          <th>Invited By</th>
                          <th>
                            Invited On
                            {showSortIcon("Invited On") && (
                              <img
                                src={swap_vert}
                                alt=""
                                role="button"
                                tabIndex={0}
                                onClick={() => handleSortClick("Invited On")}
                                onKeyDown={(e) => e.key === "Enter" && handleSortClick("Invited On")}
                                style={{ marginLeft: "5px", verticalAlign: "middle", height: "14px", cursor: "pointer" }}
                              />
                            )}
                          </th>
                          <th>Status</th>
                          <th>
                            View
                          </th>
                          {showDeleteColumn && (
                            <th>
                              {/* delete action column placeholder to keep alignment */}
                              Action
                            </th>
                          )}
                          {/* <th>
                            <button type="button" className="student-remove" onClick={handleOpenPopup} disabled={removeStudentsArray.length === 0}><i class="fa-solid fa-trash"></i> Remove</button>
                          </th> */}
                        </tr>
                        <div className="list-of-students-gap"></div>
                      </thead>
                      {isLoading ?
                        <div style={{ display: "table-caption" }}>
                          <Grid
                            height={"50vh"}
                            xs={12}
                            container
                            justifyContent={"center"}
                            alignItems={"center"}
                          >
                            <CircularProgress size={80} />
                          </Grid>
                        </div>
                        :
                        sortedInvitations && sortedInvitations?.length > 0 ? (
                          sortedInvitations?.map((invitation, index) => (
                            <>
                              <tbody>
                                <tr key={index}
                                  style={{ boxShadow: '0 1px 9px #dbdbdb', backgroundColor: '#f5fbff' }}
                                >
                                  <td data-label="Name" style={{ width: "40px" }}>

                                    {showDeleteColumn ? (
                                      (invitation?.source !== "Purchased" ? (
                                        <input
                                          value={invitation?.email}
                                          type="checkbox"
                                          onChange={handleDeleteCheck}
                                          checked={removeStudentsArray.some(element => element === invitation?.email)}
                                        />
                                      ) : (
                                        <td>-</td>
                                      ))
                                    ) : (
                                      <span aria-hidden style={{ visibility: "hidden" }}>
                                        <input type="checkbox" disabled />
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    <div className="studentrequest-profile">
                                      <div className="studentrequest-profile-image">
                                        {invitation?.source !== "Purchased" &&
                                          <img
                                            src={
                                              invitation?.student_profile_pic ||
                                              studentDashboard_AI_chatbot_image
                                            }
                                            alt="Student"
                                          />}
                                      </div>
                                      <div className="studentrequest-profile-name">
                                        {invitation?.student_name}
                                      </div>
                                    </div>
                                  </td>
                                  <td>{invitation?.email}</td>
                                  <td>
                                    <div className="studentrequest-profile">
                                      <div className="studentrequest-profile-image">
                                        {invitation?.source !== "Purchased" &&

                                          <img
                                            src={
                                              invitation?.teacher_profile_pic ||
                                              studentDashboard_AI_chatbot_image
                                            }
                                            alt="Invited by"
                                          />}
                                      </div>
                                      <div className="studentrequest-profile-name">
                                        {invitation?.invited_by ?? "-"}
                                      </div>
                                    </div>
                                  </td>
                                  <td>{invitation?.source === "Enrolled" ? (invitation?.invited_on === null ? "-" : formatDate(invitation?.invited_on)) : (invitation?.invited_on === null ? "-" : formatDate(invitation?.invited_on))}</td>
                                  <td>
                                    <div
                                      className={"LessonViewProgress-student-status" + (!invitation?.student ? "" : " " + (invitation?.source === "Enrolled" ? "enrolled_bg" : invitation?.source === "Invited" ? "invited_bg" : invitation?.source === "Rejected" ? "rejected_bg" : invitation?.source === "Purchased" ? "purchased_bg" : ""))}
                                      style={!invitation?.student ? { backgroundColor: "#FFECD6", color: "#FF8A00" } : undefined}
                                    >
                                      {!invitation?.student ? "Invited" : invitation?.source === "Invited" ? invitation?.source + " & Enrolled" : invitation?.source}
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      style={{ pointerEvents: invitation?.student_name ? 'auto' : 'none', color: invitation?.student_name ? 'blue' : 'grey' }}
                                      onClick={(e) => {
                                        if (!invitation?.student_name) return; // Do nothing if invitation doesn't exist
                                        e.preventDefault(); // This prevents the default anchor link behavior
                                        onStudentViewProfile(invitation.student);
                                      }}
                                    >
                                      View Profile
                                    </a>
                                  </td>
                                  <td>
                                    {showDeleteColumn ? (
                                      (invitation?.source !== "Purchased" ? (

                                        <img
                                          src={delete_icon}
                                          alt="Delete"
                                          role="button"
                                          tabIndex={0}
                                          onClick={() => handleOpenPopup(invitation?.email)}
                                          onKeyDown={(e) => e.key === "Enter" && handleOpenPopup(invitation?.email)}
                                          style={{ cursor: "pointer", height: "20px", width: "20px" }}
                                        />) : (
                                        <td>-</td>
                                      ))
                                    ) : (
                                      <span aria-hidden style={{ visibility: "hidden" }}>
                                        <img
                                          src={delete_icon}
                                          alt=""
                                          style={{ height: "20px", width: "20px" }}
                                        />
                                      </span>
                                    )}
                                  </td>
                                </tr>
                                <div className="blank-div"></div>
                              </tbody>
                            </>
                          ))
                        ) : (

                          <tr>
                            <td colSpan={8}>No Invitation Found</td>
                          </tr>
                        )}

                    </table>
                    {totalPages > 1 && (
                      <PaginationView
                        totalPages={totalPages}
                        next={next}
                        previous={previous}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    )}
                    {isDeletePopupOpen && (
                      <RemovePopup
                        title="Are you sure you want to remove this student?"
                        cancel="No"
                        submit="Remove"
                        onclick={handleRemoveStudent}
                        onClose={handleClose}
                        image={delete_alert_popup}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invitedstudentslist;